import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { TopProject } from '../../types/globalTypes';
import { Title } from '../Title/Title';
import { COLORS, device, FONTS } from '../../constants';
import { UpdatesList } from './UpdatesList';
import { MotionText } from '../Motion';
import { UpdatesDateList } from './UpdatesDateList';

export type TUpdatesVisualMode = 'page' | 'dropdown';

interface UpdatesProps {
  newProjectsList: TopProject[];
  visualMode: TUpdatesVisualMode;
  onLinkClick?: () => void;
}

export const Updates = ({
  newProjectsList,
  visualMode,
  onLinkClick,
}: UpdatesProps) => {
  const { t } = useTranslation();

  return (
    <UpdatesContainer>
      <TitleWrapper>
        <Title
          title={t('screen.portfolio.updates.updates')}
          fontFamily={FONTS.TITLE}
          size={visualMode === 'page' ? 36 : 24}
          lineHeight={46}
          color={COLORS.SECTION_TITLE}
        />
      </TitleWrapper>
      {visualMode === 'dropdown' ? (
        <UpdatesDateList
          newProjectsList={newProjectsList}
          visualMode={visualMode}
          onLinkClick={onLinkClick}
        />
      ) : (
        <UpdatesList
          newProjectsList={newProjectsList}
          visualMode={visualMode}
          onLinkClick={onLinkClick}
        />
      )}
    </UpdatesContainer>
  );
};

const UpdatesContainer = styled(MotionText)`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const TitleWrapper = styled.div`
  @media screen and ${device.md} {
    > span {
      font-size: 18px;
    }
  }
`;
